import React, { useState } from "react";
import { AiOutlineUpload } from "react-icons/ai";
import { useGetInsertUrl, useGetUrlList } from "../../hooks/useCrm";
import BreadCrumb from "../BreadCrumb/BreadCrumb";
import Button from "../Button/Button";
import { UpdateUrlItem } from "../Dialog/UpdateUrlItem";
import { InputField1 } from "../InputField1/InputField1";
import { Table } from "../Table/Table";
const initvalue = {
  UrlAddress: null,
};
const UrlInserter = () => {
  const [Search, setSearch] = useState("");
  const [show, setShow] = useState(false);
  const [item, setItem] = useState(null);
  const [form, setForm] = useState(initvalue);
  const { data: list } = useGetUrlList();
  const { mutateAsync: insertUrl } = useGetInsertUrl();
  const handleInsert = async (data) => {
    await insertUrl(data).then(setForm(initvalue));
  };
  console.log(list?.data?.list);
  const UrlInserterListHeader = ["ردیف", "URL", "بازدید", "عملیات"];
  const items = list?.data?.list

    ?.filter((item) => {
      if (Search === "") {
        return item;
      } else if (item.UrlAddress.includes(Search)) {
        return item;
      }
    })
    ?.map((item, index) => {
      return (
        <tr key={index}>
          <td>
            <span className="text-muted fw-bold text-muted d-block fs-7">
              {index + 1}
            </span>
          </td>
          <td>
            <span className="text-muted fw-bold text-muted d-block fs-7">
              {item?.UrlAddress}
            </span>
          </td>
          <td>
            <span className="text-muted fw-bold text-muted d-block fs-7">
              {item?.Count}
            </span>
          </td>
          <td>
            <span
              className={`text-muted fw-bold text-muted d-block fs-7 d-flex`}
            >
              <Button
                bgColor="#009EF7"
                small="fit-content"
                onclick={() => {
                  setShow(true);
                  setItem(item);
                }}
              >
                <AiOutlineUpload color="white" size={20} />
              </Button>
            </span>
          </td>
        </tr>
      );
    });
  return (
    <>
      <BreadCrumb
        margin="mt-3"
        num1="واحد CRM"
        num2="URL"
        href1="/dashboard/crm"
      />
      <div className="shadow-lg shadow-black/50 rounded-lg mx-3">
        <div className="row bg-[#EEF3F7] p-2 px-3 text-[14px] font-bold">
          ایجاد URL
        </div>
        <div className="bg-white row p-1 pb-3 rounded-b-lg">
          <div className="col-lg-4 col-12">
            <InputField1
              placeholder="https://behsod.com/apps/bazzar?content:shall"
              label="درج URL"
              onChange={(e) => setForm({ ...form, UrlAddress: e.target.value })}
              value={form?.UrlAddress ? form?.UrlAddress : ""}
            />
          </div>

          <div className="col-12 flex justify-start">
            <Button
              bgColor="#009ef7"
              small="fit-content"
              color="#fff"
              onclick={() => handleInsert(form)}
            >
              ثبت
            </Button>
          </div>
        </div>
      </div>
      <Table
        className="mt-3"
        setSearch={setSearch}
        headerTitle={UrlInserterListHeader}
        items={items}
        title={`URL ها`}
      />
      <UpdateUrlItem
        show={show}
        handleClose={() => setShow(false)}
        item={item}
      />
    </>
  );
};

export default UrlInserter;
